import { Mutations } from 'vuex-smart-module';

import { IActionItem } from '../types';

import ActionsState from './state';

export default class ActionsMutations extends Mutations<ActionsState> {
  setActions(actions: IActionItem[]) {
    this.state.actionsList = actions;
  }
}
